<template>
  <div class="mb-4">
    <h1 class="h1">{{ trans('auth.two_factor_confirmation.title') }}</h1>
    <p class="py-1"
       v-text="trans(!recovery ? 'auth.two_factor_confirmation.intro' : 'auth.two_factor_confirmation.intro_recovery')"/>
  </div>

  <form @submit.prevent="submit">
    <form-input v-if="! recovery"
                id="code"
                v-model="form.code"
                type="text"
                inputmode="numeric"
                class="mt-1 block w-full"
                autocomplete="one-time-code"
                :label-text="trans('auth.two_factor_confirmation.code')"
                :error="form.errors.code"
                autofocus/>

    <form-input v-else
                id="recovery_code"
                v-model="form.recovery_code"
                type="text"
                class="mt-1 block w-full"
                autocomplete="one-time-code"
                :label-text="trans('auth.two_factor_confirmation.recovery_code')"
                :error="form.errors.recovery_code"
                autofocus/>

    <div class="flex items-center justify-end mt-4">
      <form-button class="ml-4" :value="trans('auth.login.title')" :processing="form.processing"/>
    </div>

    <div class="flex justify-content-between align-items-center mt-4 pt-4 border-top">
      <button type="button" class="text-sm text-gray-600 hover:text-gray-900 underline cursor-pointer"
              @click.prevent="toggleRecovery"
              v-text="trans(!recovery ? 'auth.two_factor_confirmation.use_recovery_code' : 'auth.two_factor_confirmation.use_authentication_code')"/>

      <language-toggle :route-to="{name: 'two-factor.login'}"/>
    </div>
  </form>
</template>

<script>
import AuthLayout from '@/Layouts/AuthLayout';

export default {
  layout: AuthLayout,
};
</script>

<script setup>
import {nextTick, ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import LanguageToggle from "@/components/Shared/LanguageToggle";
import FormInput from "@/components/Shared/Form/Input/Index";
import FormButton from "@/components/Shared/Form/Button";
import {useLocales} from "@/composables/locales";

const localeRoute = useLocales().localeRoute

const recovery = ref(false);
const form = useForm({
  code: '',
  recovery_code: '',
});

const toggleRecovery = async () => {
  recovery.value ^= true;
  await nextTick();

  if (recovery.value) {
    form.code = '';
  } else {
    form.recovery_code = '';
  }
};

const submit = () => {
  form.post(localeRoute('two-factor.login'));
};
</script>
